import React from 'react';

const Home = () => (
  <div>{'Bienvenue sur l\'administration Fasst'}</div>
);

export default Home;
